
/**** 
 * BLOCK FREE SHIPPING
 ****/
// 1. Set constants
let LIMIT_FREE_SHIPPING = 149;
let IS_ACTIVE_FREE_SHIPPING = true;
  

// 2. Set block of free shipping
function setFreeShippingBlock(scope = null) {
    // console.log("setFreeShippingBlock");
    let totalCart = 0;
    let percentageProgress = 0;
    let diffPromotion = LIMIT_FREE_SHIPPING;
    let cartSubtotal = 0;
    let cartDiscounts = 0;
    
    function getTotalCart() {
        let total_cart = null;

        if(scope && scope === "cart_page") {
            total_cart = jQuery(".m-cart__footer .m-cart__footer--wrapper .m-cart__subtotal--price").text().split("S/.")[1].trim();
            // total_cart = Number(total_cart) / 100
            total_cart = Number(total_cart)

        } else {
            total_cart = jQuery(".m-cart-drawer__footer .m-cart__subtotal .m-cart__subtotal--price").text().split("S/.")[1].trim();
            // total_cart = Number(total_cart) / 100
            total_cart = Number(total_cart)
        }
            
        return total_cart
    }

    cartSubtotal = getTotalCart();
    // cartDiscounts = Math.abs(elem["value"] / 100);
    cartDiscounts = 0;
  
    if (cartSubtotal > 0) {
        totalCart = cartSubtotal - cartDiscounts;
        if (totalCart >= LIMIT_FREE_SHIPPING) {
            percentageProgress = 100;
            diffPromotion = 0;
        } else {
            percentageProgress = (totalCart / LIMIT_FREE_SHIPPING) * 100;
            diffPromotion = LIMIT_FREE_SHIPPING - totalCart;
        }
        var textPromotion = `Te faltan S/ ` + diffPromotion.toFixed(2) + ` para obtener un envío gratis!`;
        if (diffPromotion == 0) {
            textPromotion = `¡TIENES ENVÍO GRATIS EN ESTE PEDIDO!`;
        }

        // HTML
        var templateFreShipping = ``;
        if (totalCart > 0) {
            templateFreShipping = `
            <div class="enova_free-shipping__wrapper">
                <div class="enova_free-shipping__container">
                    <div class="enova_free-shipping__block__text">
                        <p class="enova_free-shipping__block__text_description">Envio Gratis por compras mayores a s/ ${LIMIT_FREE_SHIPPING}</p>
                    </div>
                    <div class="enova_free-shipping__block__thermometer">
                        <div class="enova_free-shipping__block__thermometer-load">
                            <div class="enova_free-shipping__block__thermometer-load-gray"></div>
                            <div class="enova_free-shipping__block__thermometer-load-black" style="width: ${percentageProgress}%;"></div>
                        </div>
                        <div class="enova_free-shipping__block__thermometer_text-container">
                            <p class="enova_free-shipping__block__thermometer_text">${textPromotion}</p>
                        </div>
                    </div>
                </div>
            </div>
            `
        } else {
            templateFreShipping = `
            <div class="enova_free-shipping__wrapper">
                <div class="enova_free-shipping__container">
                    <div class="enova_free-shipping__block__text">
                        <p class="enova_free-shipping__block__text_description">Envio Gratis por compras mayores a S/ ${LIMIT_FREE_SHIPPING}</p>
                    </div>
                </div>
            </div>
            `
        }
    
        // if (!(jQuery(".enova_free-shipping__container") && jQuery(".enova_free-shipping__container")[0])) {
        //     jQuery(".m-cart__footer").before(templateFreShipping);
        // }

        // rewrite
        if(scope && scope === "cart_page") {
            
            if (jQuery(".enova_free-shipping__wrapper") && jQuery(".enova_free-shipping__wrapper")[0]) {
                jQuery(".enova_free-shipping__wrapper").remove()
            }
            jQuery(".m-cart__footer--wrapper").prepend(templateFreShipping);

        } else {
            if (jQuery(".enova_free-shipping__wrapper") && jQuery(".enova_free-shipping__wrapper")[0]) {
                jQuery(".enova_free-shipping__wrapper").remove()
            } 
            jQuery(".m-cart-drawer__footer").before(templateFreShipping);
        }
    }

}

var checkerEventCartSetFreeShippingBlock = setInterval(() => {
    // mini cart
    if (jQuery(".m-cart-drawer__footer") &&
        jQuery(".m-cart-drawer__footer").length > 0 &&
        // !document.querySelector(".enova_free-shipping__wrapper") &&
        IS_ACTIVE_FREE_SHIPPING) {
        setFreeShippingBlock();
    }

    // cart page
    if (jQuery(".m-cart__footer") &&
        jQuery(".m-cart__footer").length > 0 &&
        location.pathname.indexOf("cart") != -1 &&
        // !document.querySelector(".enova_free-shipping__wrapper") &&
        IS_ACTIVE_FREE_SHIPPING) {
        setFreeShippingBlock("cart_page");
    }
    

}, 1000)

// jQuery(".summary-template-holder .row-fluid");









document.addEventListener("DOMContentLoaded", function() {
    // Función para traducir el mes
    function translateMonth(month) {
      const months = {
        'Jan': 'Ene', 'Feb': 'Feb', 'Mar': 'Mar', 'Apr': 'Abr', 'May': 'May', 'Jun': 'Jun',
        'Jul': 'Jul', 'Aug': 'Ago', 'Sep': 'Sep', 'Oct': 'Oct', 'Nov': 'Nov', 'Dec': 'Dic'
      };
      return months[month] || month;
    }

    // Función para formatear la fecha
    function formatSpanishDate(dateString) {
      const parts = dateString.split(' ');
      const month = translateMonth(parts[0]);
      return `${month} ${parts[1]}`;
    }

    // Obtiene los elementos por ID y actualiza su contenido
    const fromEl = document.getElementById('deliveryFrom');
    const toEl = document.getElementById('deliveryTo');
    if (fromEl && toEl) {
      fromEl.textContent = formatSpanishDate(fromEl.textContent);
      toEl.textContent = formatSpanishDate(toEl.textContent);
    }
  });






